import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useParams } from "react-router-dom";
import SlackSchedulerForm from "./Form";
import {
  SG_FETCH_SLACK_SCHEDULER,
  SG_EDIT_SLACK_SCHEDULER,
  SG_GET_SLACK_BOT_SELECT,
} from "constants/actions";

const UpdateSlackScheduler = () => {
  const dispatch = useDispatch();

  const { id } = useParams();
  const [slackScheduler, setSlackScheduler] = useState({});
  useEffect(() => {
    // Redirect to details page
    dispatch({ type: SG_FETCH_SLACK_SCHEDULER, payload: { id } });
  }, [dispatch, id]);

  const handleSubmit = (formData) => {
    dispatch({ type: SG_EDIT_SLACK_SCHEDULER, payload: formData });
  };

  useEffect(() => {
    dispatch({ type: SG_GET_SLACK_BOT_SELECT });
  }, [dispatch]);

  const { get_slack_scheduler, get_errors } = useSelector(
    (state) => ({
      get_errors: state.errors,
      get_slack_scheduler: state.slack_scheduler,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (id) {
      setSlackScheduler(get_slack_scheduler?.[id]);
    }
  }, [get_slack_scheduler, id]);

  return (
    <div>
      <h1>
        Update Slack Scheduler [NOT RECOMMENDED TO CHANGE VALUES IN PRODUCTION]
      </h1>
      <SlackSchedulerForm
        onSubmit={handleSubmit}
        initialData={slackScheduler}
        editId={id}
      />
    </div>
  );
};

export default UpdateSlackScheduler;
